export default "__VITE_ASSET__18ffc085__"